import React, { useState } from "react";
import { LEGEND_PORTRAITS, capitalize } from "./legendData";

const legendKeys = Object.keys(LEGEND_PORTRAITS);

function getRandomLegendKey(): string {
  return legendKeys[Math.floor(Math.random() * legendKeys.length)];
}

// ─── Component-scoped styles ────────────────────────────────────────────────────
function RandomizerStyles() {
  return (
    <style>{`
      .lr-result {
        display: flex;
        align-items: center;
        gap: 16px;
        background: var(--bg-card);
        border: 1px solid var(--border);
        border-radius: var(--radius-md);
        padding: 16px 20px;
        max-width: 420px;
      }
      .lr-result img {
        width: 54px;
        height: 54px;
        object-fit: cover;
        border-radius: 10px;
        flex-shrink: 0;
      }
      .lr-result span {
        font-size: 1.3em;
        font-weight: 700;
      }
      .lr-empty {
        color: var(--text-muted);
        padding: 20px 0;
      }
    `}</style>
  );
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function LegendRandomizerPage({ navigateTo }: { navigateTo: (path: string) => void }) {
  const [resultKey, setResultKey] = useState<string | null>(null);

  const randomize = () => {
    setResultKey(getRandomLegendKey());
  };

  return (
    <div className="page-inner">
      <RandomizerStyles />

      <button onClick={() => navigateTo("/tools")} className="btn btn--secondary mb-16">
        ← Back to Tools
      </button>

      <div className="card roster-page-header">
        <div className="label-accent mb-12">QUIT</div>
        <div className="flex justify-between items-center gap-20 flex-wrap">
          <h1 style={{ margin: 0, fontSize: 46, lineHeight: 1.05 }}>Legend Randomizer</h1>
        </div>
        <p className="text-muted mb-0 mt-8">Rolls a random legend.</p>
      </div>

      <div className="mb-16">
        <button className="btn" onClick={randomize}>Randomize Legend</button>
      </div>

      <div className="card">
        {!resultKey ? (
          <div className="lr-empty">Hit "Randomize Legend" to roll one.</div>
        ) : (
          <div className="lr-result">
            <img
              src={LEGEND_PORTRAITS[resultKey]}
              alt={capitalize(resultKey)}
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.visibility = "hidden"; }}
            />
            <span>{capitalize(resultKey)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
